module.exports = __webpack_public_path__ + "static/media/listyour-practice.aac51f5b.jpg";